import { combineReducers } from '@reduxjs/toolkit';
import createCategoryReducer from './create/createSlice';
import categoryListReducer from './list/listSlice';
import deleteCategoryReducer from './delete/deleteSlice';

const categorySlice = combineReducers({
    create: createCategoryReducer,
    list: categoryListReducer,
    delete: deleteCategoryReducer,
});

export default categorySlice;
